<template>
  <!--prettier-ignore-->
  <div
    class="text-center space-x-4 bg-neutral-600 py-3 text-xs font-medium text-white"
  >
    Your profile is currently hidden. Toggle available session times on to go live <InertiaLink href="/settings/account/sessions" class="underline">here</InertiaLink>.
  </div>
</template>

<script setup></script>
